/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconBaseline = createReactComponent("outline", "baseline", "IconBaseline", [["path", { "d": "M4 20h16", "key": "svg-0" }], ["path", { "d": "M8 16v-8a4 4 0 1 1 8 0v8", "key": "svg-1" }], ["path", { "d": "M8 10h8", "key": "svg-2" }]]);

export { IconBaseline as default };
//# sourceMappingURL=IconBaseline.mjs.map
